import {
	IStorageAccessor,
	InterfaceFor
} from 'util/domain';
import {
	DAYS_UNTIL_EXPIRATION,
	HelpBlurb
} from 'sharebase/domain';

const VIEWED_HELP_BLURBS_KEY = 'sb-viewed-help-blurbs';

export class HelpBlurbDataStore {
	public static $inject = [
		'localStorageService'
	]
	
	public viewedHelpBlurbs:{ [s:string]:Date };

	constructor(
		private readonly localStorageService:IStorageAccessor
	){
		let storedViewedBlurbs = localStorageService.getStoredValue(VIEWED_HELP_BLURBS_KEY);
		this.viewedHelpBlurbs = storedViewedBlurbs ? JSON.parse(storedViewedBlurbs) : {};
		this.removeOldBlurbs();
	}

	public updateExpirationDate(blurb:HelpBlurb) {
		this.viewedHelpBlurbs[blurb.storageKey] = blurb.viewedExpirationDate;
		this.localStorageService.setStoredValue(VIEWED_HELP_BLURBS_KEY, JSON.stringify(this.viewedHelpBlurbs));
	}

	private removeOldBlurbs() {
		//If it was viewed more than 3 months ago, remove it from the local storage
		//This is based on a rolling expiration to remove entries from local storage that no longer exist in templates
		let blurbCutoffDate = new Date();
		blurbCutoffDate.setDate(blurbCutoffDate.getDate() - DAYS_UNTIL_EXPIRATION);

		for (let key in this.viewedHelpBlurbs) {
			if(this.viewedHelpBlurbs[key] < blurbCutoffDate) {
				delete this.viewedHelpBlurbs[key];
			}
		}

		this.localStorageService.setStoredValue(VIEWED_HELP_BLURBS_KEY, JSON.stringify(this.viewedHelpBlurbs));
	}
}

export class NullHelpBlurbDataStore implements InterfaceFor<HelpBlurbDataStore> {
	public viewedHelpBlurbs:{ [s:string]:Date };
	public updateExpirationDate = angular.noop;
}


// WEBPACK FOOTER //
// ./src/sharebase/dataStores/help-blurb-datastore.ts